import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    Pressable,
    ScrollView,
    Platform
} from "react-native";

import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Text from "../components/Text";
import * as Constants from "../utils/Constants";
import * as Animatable from "react-native-animatable";
import * as ServerOperations from "../utils/ServerOperations";
import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";
import DesktopSidebar from "../utils/DesktopSidebar";
import InvoiceDetails from "./InvoiceDetails";
import SplashScreen from "./Splash";
let height = Dimensions.get("window").height;
let width = Dimensions.get("window").width;
let styles = {};
let isMobile = false;
let scale = 1;
const SOAimg = require("../images/ClientHomePage/SOA.png");
const IRimg = require("../images/ClientHomePage/IR.png");
const OrderImg = require("../images/ClientHomePage/Order.png");
const imgProfile = require("../images/Header/Profile.png");
const imgJdsLogo = require("../images/Header/JdsLogo.png");
const CloseIcon = require("../images/InvoiceDetails/closeIcon.png");
const imgArrowDown = require("../images/MyOrders/OrderArrowDown.png");
const imgCalender = require("../images/StatementOfAccount/calender.png");

class ClientHomePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showOrderDetails: false,
            accountInfo: {},
            orders: [],
            detailsOrderNo: '',
            detailsOrderInvoice: '',
            detailsOrderDate: '',
            orderDetails: [],
            orderTimeline: [],
            showOrderTimeline: false,
            orderTimelineLastItem: [],
            LastOrderStatus: [],
            LastOrderView: [],
            soaBackgroundColor: '#F5F5F5',
            invoiceBackgroundColor: '#F5F5F5',
            myOrderBackgroundColor: '#F5F5F5',
            profileBackgroundColor: '#F5F5F5',
            showProfilePage: false,
            showSoaPage: false,
            showInRetPage: false,
            showMyOrdersPage: false,
            selectedFromDate: '',
            selectedToDate: '',
            userImage: '',
            userName: '',
            soaData: [],
            ordersData: [],
            selectedTab: '',
            slpashRendered: false,
            showDesktopOrderDetails: false,
            Invoices: [],
            invoiceTotal: '',
            flag: 0,
            InvNo: '',
            InvDate: '',
            InvValue: '',
            showInvDetails: false,
            Returns: [],
            RetNo: '',
            RetDate: '',
            RetValue: '',
            ReturnTotal: '',
            showRetDetails: false,
            ReturnDetails: [],
        };
    }
    Pressables = {};

    async componentDidMount() {
        const lastSplashDate = await Commons.getFromAS('LAST_SPLASH_DATE');
        const currentDate = new Date().toDateString();
        if (!lastSplashDate || lastSplashDate !== currentDate) {
            await Commons.saveToAS('LAST_SPLASH_DATE', currentDate);
            setTimeout(() => {
                this.setState({ slpashRendered: true });
            }, 3000);
        } else {
            this.setState({ slpashRendered: true });
        }

        const accountInfo = await ServerOperations.getUserInfo();
        if (accountInfo) {
            this.setState({ accountInfo, userImage: accountInfo.IMGURL, userName: accountInfo.NAME });
        }
        let resp = await ServerOperations.getOrders('', '', '');
        if (resp.ORDS) {
            this.setState({ orders: resp.ORDS });
            console.log(resp);
        } else {
            const token = await Commons.getFromAS(Constants.TOKEN);
            if (!token) {
                window.location = './login';
            }
        }


    }



    renderHeaderMobile = () => {
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', padding: 20, alignSelf: "stretch", justifyContent: "space-between" }}>
                <TouchableOpacity>
                    <Image source={imgJdsLogo} style={{
                        width: 35.063,
                        height: 37,
                        padding: 1,
                        resizeMode: "contain",
                    }} />
                </TouchableOpacity>
                {this.state.accountInfo.NAME &&
                    <Text style={[AppStyles.H2Styles, { textAlign: 'center', width: width - 130 },
                    this.state.accountInfo.NAME.length > 30 && { fontSize: 18 },
                    this.state.accountInfo.NAME.length > 40 && { fontSize: 16 },
                    ]}>
                        {this.state.accountInfo.NAME}
                    </Text>
                }
                <TouchableOpacity onPress={() => window.location = './profile'}>
                    <Image source={imgProfile} style={{ width: 20, height: 20, stroke: Styles.appColor1 }}></Image>
                </TouchableOpacity>
            </View>
        )
    }

    renderHeaderDialog = () => {
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', padding: 30, alignSelf: "stretch", justifyContent: "space-between", height: 75 }}>
                <TouchableOpacity>
                    {/* <Image source={CloseIcon} style={{width: 14, height: 14}} /> */}
                </TouchableOpacity>
                <TouchableOpacity
                    onPress={() => {
                        this.setState({ showOrderDetails: false, showOrderTimeline: false });
                    }}>
                    <Image source={CloseIcon} style={{ width: 14, height: 14 }} />
                </TouchableOpacity>
            </View>
        )


    }

    renderMobile() {
        if (!this.state.slpashRendered) {
            return <SplashScreen />
        }
        scale = width / 420;
        return (
            <View style={styles.container}>
                {this.state.showOrderDetails == false && this.renderHeaderMobile()}
                <ScrollView
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    <View style={{ width, }}>
                        {Commons.loadFonts(this, false)}
                        {Styles.renderVSeparator(0)}
                        {this.renderPart1Mobile()}
                        {this.renderPart2Mobile()}
                        {this.renderPart3Mobile()}
                        {this.renderPart4Mobile()}
                    </View>
                </ScrollView>
                {this.state.showOrderDetails == true && this.renderOrderDetailsMobile()}

            </View >
        );
    }



    loadInvoices = async () => {
        let resp = await ServerOperations.getInvoices(this.state.selectedFromDate, this.state.selectedToDate, '');
        const invData = resp.INVS.map((item) => {
            return (
                <Pressable style={{ width: 912 }}>
                    <TouchableOpacity style={{ flexDirection: 'row', marginHorizontal: 50, marginTop: 20, height: 50, borderBottomColor: 'rgba(0, 0, 0, 0.16)', borderBottomWidth: 1.5, width: 912, justifyContent: 'flex-start', gap: 210 }}
                        onPress={() => { this.setState({ InvNo: item.ID, InvDate: item.DATE, InvValue: item.VALUE, showInvDetails: true }) }}>
                        <Text style={[AppStyles.BodyTextInvDetailsStyles, { marginHorizontal: 18 }]}>{item.ID}</Text>
                        <Text style={[AppStyles.BodyTextInvDetailsStyles, {}]}>{item.DATE}</Text>
                        <Text style={[AppStyles.BodyTextInvDetailsStyles, { marginHorizontal: 35 }]}> {item.VALUE}</Text>
                    </TouchableOpacity>
                </Pressable>
            )
        });
        this.setState({ selectedFromDate: resp.FROM_DATE, selectedToDate: resp.TO_DATE, Invoices: invData, invoiceTotal: resp.TOTAL });
        console.log(resp);
    }


    loadReturns = async () => {
        resp = await ServerOperations.getReturns(this.state.selectedFromDate, this.state.selectedToDate, '');
        const returnsData = resp.INVS.map((item) => {
            return (
                <TouchableOpacity style={{ flexDirection: 'row', marginHorizontal: 50, marginTop: 20, height: 50, borderBottomColor: 'rgba(0, 0, 0, 0.16)', borderBottomWidth: 1.5, width: 912, justifyContent: 'flex-start', gap: 210 }}
                    onPress={() => {
                        this.setState({ RetNo: item.ID, RetDate: item.DATE, RetValue: item.VALUE, showRetDetails: true });
                    }}>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { marginHorizontal: 18 }]}>{item.ID}</Text>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, {}]}>{item.DATE}</Text>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { marginHorizontal: 35 }]}> {item.VALUE}</Text>
                </TouchableOpacity>
            )
        });
        this.setState({ selectedFromDate: resp.FROM_DATE, selectedToDate: resp.TO_DATE, Returns: returnsData, ReturnTotal: resp.TOTAL });
    }



    renderRequestButton = (type) => {
        return (
            <TouchableOpacity style={[AppStyles.loginButtonStyles, { width: 109, height: 43, }]}
                onPress={async () => {
                    loaderHandler.showLoader(STRINGS.loading, this);
                    // await this.loadSoa();
                    // if (type == 'soa') { await this.loadSoa(); this.setState({ flag: 1 }) }
                    if (type == 'myorders') { await this.loadMyOrders(); this.setState({ flag: 1 }) }
                    if (type == 'invoices') { await this.loadInvoices(); this.setState({ flag: 1 }) }
                    if (type == 'returns') { await this.loadReturns(); this.setState({ flag: 1 }) }
                }}>
                <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.Request}</Text>
            </TouchableOpacity>
        )
    }


    renderDateSelection = () => {
        return (
            <View style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 7, flexDirection: 'row' }}>

                <TouchableOpacity
                    onPress={() => {
                        if (Platform.OS === 'web') {
                            this.fromDateInput.showPicker();
                        } else {
                            // Handle other platforms if necessary
                        }
                    }}
                    style={{
                        display: 'flex', height: 40, flexDirection: 'row', width: 265, justifyContent: 'space-between',
                        alignItems: 'center', borderRadius: 10, borderWidth: 1, borderColor: 'rgba(59, 98, 127, 0.50)', backgroundColor: '#FFF'
                    }}>
                    <Text style={[AppStyles.FromToDateTextStyle, { position: 'absolute', top: -10, left: 10, backgroundColor: 'white', width: 35 }]}>{STRINGS.from}</Text>
                    <Text style={[AppStyles.dateTextStyle2, { paddingHorizontal: 10 }]}>{this.state.selectedFromDate}</Text>
                    <Image source={imgCalender} style={{ width: 17, height: 17, marginRight: 10 }} />
                    {Platform.OS === 'web' && (
                        <input
                            ref={e => this.fromDateInput = e}
                            type="date"
                            value={this.state.selectedFromDate}
                            onChange={(e) => this.setState({ selectedFromDate: e.target.value, })}
                            style={{ position: 'absolute', top: 0, left: 0, opacity: 0, width: '100%', height: '100%' }}

                        />
                    )}
                </TouchableOpacity>

                <TouchableOpacity
                    onPress={() => {
                        if (Platform.OS === 'web') {
                            this.toDateInput.showPicker();
                        } else {
                            // Handle other platforms if necessary
                        }
                    }}
                    style={{ display: 'flex', height: 40, flexDirection: 'row', width: 265, justifyContent: 'space-between', alignItems: 'center', borderRadius: 10, borderWidth: 1, borderColor: 'rgba(59, 98, 127, 0.50)', backgroundColor: '#FFF' }}>
                    <Text style={[AppStyles.FromToDateTextStyle, { position: 'absolute', top: -10, left: 10, backgroundColor: 'white', width: 20 }]}>{STRINGS.to}</Text>
                    <Text style={[AppStyles.dateTextStyle2, { paddingHorizontal: 10 }]}>{this.state.selectedToDate}</Text>
                    <Image source={imgCalender} style={{ width: 17, height: 17, marginRight: 10 }} />
                    {Platform.OS === 'web' && (
                        <input
                            ref={e => this.toDateInput = e}
                            type="date"
                            value={this.state.selectedToDate}
                            onChange={(e) => this.setState({ selectedToDate: e.target.value, })}
                            style={{ position: 'absolute', top: 0, left: 0, opacity: 0, width: '100%', height: '100%' }}
                        />
                    )}
                </TouchableOpacity>
            </View>
        )
    }



    renderInvoicesDesktop = () => {
        const InvoicesHeaders = [
            { title: STRINGS.Desktop_invoice_number, margHorz: 18 },
            { title: STRINGS.Date_desktop_date, margHorz: undefined },
            { title: STRINGS.Desktop_Total, margHorz: undefined },
        ];
        return (
            <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', }}>
                <Text style={[AppStyles.H2Styles, { marginLeft: 50, marginTop: 80 }]}>{STRINGS.Invoices}</Text>
                <View style={{ flexDirection: 'row', gap: 20, marginHorizontal: 50, marginTop: 16 }}>
                    {this.renderDateSelection()}
                    {this.renderRequestButton('invoices')}
                </View>

                {this.state.flag == 1 && (
                    <View>
                        <View style={{ display: 'flex', backgroundColor: '#DBE2E8', borderTopRightRadius: 16, borderTopLeftRadius: 16, marginTop: 20, flexDirection: 'row', marginHorizontal: 50, marginTop: 40, width: 912, justifyContent: 'flex-start', gap: 240 }}>
                            {InvoicesHeaders.map((header) => {
                                return (
                                    <View style={{ height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', marginHorizontal: header.margHorz }}>
                                        <Text style={[AppStyles.H3Styles, { textAlign: 'center' }]}>{header.title}</Text>
                                    </View>
                                )
                            })}
                        </View>
                        <ScrollView style={{ height: 600, }} showsVerticalScrollIndicator={false}>
                            {this.state.Invoices}
                        </ScrollView>
                    </View>
                )}
            </View>
        )
    }

    renderReturnsDesktop = () => {
        const ReturnsHeaders = [
            { title: STRINGS.Desktop_invoice_number, width: 300, margHorz: 18 },
            { title: STRINGS.Date_desktop_date, width: 300, margHorz: undefined },
            { title: STRINGS.Desktop_Total, width: 300, margHorz: undefined },
        ];
        return (
            <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', }}>
                <Text style={[AppStyles.H2Styles, { marginLeft: 50, marginTop: 80 }]}>{STRINGS.Returns}</Text>
                <View style={{ flexDirection: 'row', gap: 20, marginHorizontal: 50, marginTop: 16 }}>
                    {this.renderDateSelection()}
                    {this.renderRequestButton('returns')}
                </View>

                {this.state.flag == 1 && (
                    <View>
                        <View style={{ display: 'flex', backgroundColor: '#DBE2E8', borderTopRightRadius: 16, borderTopLeftRadius: 16, marginTop: 20, flexDirection: 'row', marginHorizontal: 50, marginTop: 40, width: 912, justifyContent: 'flex-start', gap: 250 }}>
                            {ReturnsHeaders.map((header) => {
                                return (
                                    <View style={{ height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', marginHorizontal: header.margHorz }}>
                                        <Text style={[AppStyles.H3Styles, { textAlign: 'center' }]}>{header.title}</Text>
                                    </View>
                                )
                            })}
                        </View>
                        <ScrollView style={{ height: 600, }} showsVerticalScrollIndicator={false}>
                            {this.state.Returns}
                        </ScrollView>
                    </View>
                )}

            </View>
        )
    }


    render() {
        this.title = 'Client Home Page';
        width = Dimensions.get("window").width;
        isMobile = Commons.isMobile();
        if (isMobile) {
            window.location = './Login';
            return null;
            // Commons.resizeHandle(window, this, () => {
            //     width = this.width;
            //     height = this.height;
            // });
            // styles = this.styles();
            // return this.renderMobile();
        }
        // width = Commons.getWidth();
        styles = this.styles();
        return (
            <View style={styles.container}>
                <DesktopSidebar
                    selectedTab={STRINGS.shop_home}
                >
                </DesktopSidebar>
            </View>
        );
    }




    renderPart1Mobile = () => {
        return (
            <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', gap: 8, backgroundColor: 'rgba(235, 239, 242, 0.50)', height: 150 }}>
                <Text style={[AppStyles.H3Styles, { paddingHorizontal: 32 }]}>{STRINGS.Due_Balance}</Text>
                <Text style={[AppStyles.DueBalanceNumStyle, { paddingHorizontal: 32 }]}>
                    {this.state.accountInfo.BALANCE}
                    <Text style={[AppStyles.DueBalanceTextStyle, { marginLeft: 2 }]}>
                        JOD
                    </Text>
                </Text>
            </View>
        )
    }

    renderPart2 = () => {

    }

    renderPart2Mobile = () => {
        return (
            <View style={{
                display: 'flex',
                width: width - 40,
                alignItems: 'flex-start',
                gap: 16,
                flexWrap: 'wrap',
                paddingHorizontal: 20,
                marginTop: 30
            }}>
                <View style={{ flexDirection: 'row', gap: 16, width: width - 40 }}>
                    <TouchableOpacity style={[AppStyles.cardStyle]}
                        onPress={() => {
                            window.location = './StatementOfAccount';
                        }}>
                        <Image source={SOAimg} style={{ height: 32, width: 32, marginTop: 16 }} />
                        <Text style={[AppStyles.H3Styles, { marginBottom: 16 }]}>{STRINGS.Statement_of_Account}</Text>
                    </TouchableOpacity>

                    <TouchableOpacity style={[AppStyles.cardStyle]}
                        onPress={() => {
                            window.location = './InvoicesReturns';
                        }}>
                        <Image source={IRimg} style={{ height: 32, width: 32, marginTop: 16 }} />
                        <Text style={[AppStyles.H3Styles, { marginBottom: 16 }]}>{STRINGS.Invoice_Returns}</Text>
                    </TouchableOpacity>
                </View>
                <TouchableOpacity style={[AppStyles.MyOrdersStyle, { height: 114, width: width - 40 }]}
                    onPress={() => {
                        window.location = './myorders';
                    }}>
                    <Image source={OrderImg} style={{ height: 32, width: 32, marginTop: 16 }} />
                    <Text style={[AppStyles.H3Styles, { marginBottom: 16 }]}>{STRINGS.Orders}</Text>
                </TouchableOpacity>
                <View style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', alignSelf: 'stretch', flexDirection: 'row', marginTop: 32 }}>
                    <Text style={[AppStyles.H3Styles, { flex: 1 }]}>{STRINGS.Active_Orders}</Text>
                    {/* <TouchableOpacity>
                        <Text style={[AppStyles.ButtonTextStyles, {
                            maxWidth: 128,
                            color: '#50B0FF',
                            textDecorationLine: 'underline'
                        }]}>{STRINGS.All_Orders}</Text>
                    </TouchableOpacity> */}
                </View>
            </View>
        );
    }

    renderPart3 = () => {

    }

    getOrderDetails = async (orderNo) => {
        let resp = await ServerOperations.getOrders('', '', orderNo);
        this.setState({ orderDetails: resp.ITEMS, orderTimeline: resp.TIMELINE });
        console.log(resp);
    }

    renderPart3Mobile = () => {
        const ActiveOrders = this.state.orders.map((order) => (
            <TouchableOpacity style={[AppStyles.AllOrdersStyle, { width: width - 40 }]}
                onPress={async () => {
                    loaderHandler.showLoader(STRINGS.loading, this);
                    await this.getOrderDetails(order.ORD_NO);
                    this.setState({ detailsOrderNo: order.ORD_NO, detailsOrderDate: order.EST_DLV, detailsOrderInvoice: order.INV_NO, showOrderDetails: true });
                    loaderHandler.hideLoader();
                }}>
                <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 8, alignSelf: 'stretch' }}>
                    <Text style={{ height: 10 }}></Text>
                    <Text style={[AppStyles.BodyTextStyles]}>Order #{order.ORD_NO}</Text>
                    <Text style={[AppStyles.SecondaryTextStyles, { color: 'rgba(20, 36, 46, 0.62)' }]}>Est Delivery: {order.EST_DLV}</Text>
                    <Text style={[AppStyles.SecondaryTextStyles, { color: 'rgba(20, 36, 46, 0.62)' }]}>Order Value: {order.VALUE}</Text>
                    <Text style={{ height: 10 }}></Text>
                </View>
                <View style={{ display: 'flex', width: 85, flexDirection: 'column', alignItems: 'center', gap: 8 }}>
                    <View style={{ width: 22, height: 22, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                    <Text style={[AppStyles.H3Styles, { textAlign: 'center' }]}>{order.STATUS}</Text>
                </View>
            </TouchableOpacity>
        ));
        return (
            <View style={{ flexDirection: 'column', gap: 14, marginTop: 24, paddingHorizontal: 20 }}>
                {ActiveOrders}
            </View>
        )
    }

    renderPart4 = () => {

    }

    renderPart4Mobile = () => {
        return (
            <View style={{ height: 100 }}>

            </View>
        )
    }

    renderOrderDetailsMobile = () => {
        var TimelineCount = this.state.orderTimeline.length;
        console.log(TimelineCount);
        const OrderTimeline = this.state.orderTimeline.map((order, index) => (
            <View>
                {index < TimelineCount - 1 && (
                    <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', alignSelf: 'stretch', backgroundColor: '#FFF', paddingHorizontal: 22 }}>
                        <View style={{ flexDirection: 'row', gap: 16, alignSelf: 'stretch' }}>
                            <View style={{ alignItems: 'center', justifyContent: 'center', alignSelf: 'stretch' }}>
                                <View style={{ height: 130, width: 4, backgroundColor: 'rgba(37, 89, 126, 0.09)', justifyContent: 'center', alignItems: 'center' }}>
                                    <View style={{ width: 22, height: 22, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                                </View>
                            </View>
                            <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', flex: 1 }}>
                                <Text style={[AppStyles.H3Styles]}>{order.STATUS}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.COMMENT}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.DATE} </Text>
                            </View>
                        </View>
                    </View>
                )}
                {index == TimelineCount - 1 && (order.COLOR == '#6ba461' || order.COLOR == '#D70202') && TimelineCount - 1 != 0 && (
                    <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', alignSelf: 'stretch', backgroundColor: '#FFF', paddingHorizontal: 13 }}>
                        <View style={{ flexDirection: 'row', gap: 8, alignSelf: 'stretch' }}>
                            <View style={{ alignItems: 'center', justifyContent: 'center', alignSelf: 'stretch', flexDirection: 'column' }}>
                                <View style={{ height: 70, width: 4, backgroundColor: 'rgba(37, 89, 126, 0.09)', justifyContent: 'center', alignItems: 'center' }} />
                                <View style={{ width: 22, height: 22, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                            </View>
                            <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', flex: 1 }}>
                                <Text style={[AppStyles.H3Styles]}>{order.STATUS}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.COMMENT}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.DATE} </Text>
                            </View>
                        </View>
                    </View>
                )}
                {index == TimelineCount - 1 && order.COLOR != '#6ba461' && order.COLOR != '#D70202' && (
                    <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', alignSelf: 'stretch', backgroundColor: '#FFF', paddingHorizontal: 22 }}>
                        <View style={{ flexDirection: 'row', gap: 16, alignSelf: 'stretch' }}>
                            <View style={{ alignItems: 'center', justifyContent: 'center', alignSelf: 'stretch' }}>
                                <View style={{ height: 130, width: 4, backgroundColor: 'rgba(37, 89, 126, 0.09)', justifyContent: 'center', alignItems: 'center' }}>
                                    <View style={{ width: 22, height: 22, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                                </View>
                            </View>
                            <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', flex: 1 }}>
                                <Text style={[AppStyles.H3Styles]}>{order.STATUS}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.COMMENT}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.DATE} </Text>
                            </View>
                        </View>
                    </View>
                )}
            </View>
        ));


        const OrderDetails = this.state.orderDetails.map((order) => (
            <View style={[AppStyles.InvoiceDetailsMainViewStyle, { paddingHorizontal: 20, marginTop: 32 }]}>
                <View style={{ display: 'flex', alignItems: 'center', gap: 24, flexDirection: 'row', width: width - 40 }}>
                    <View style={{ flexDirection: 'column', gap: 6 }}>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>{STRINGS.Item}</Text>
                        {Commons.getTextWidth(order.ITEM_CODE) > (width - 180) && <Text style={[[AppStyles.InvoiceDetailsItemsStyle, {}]]}>  </Text>}
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>{STRINGS.Qty_Details}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>{STRINGS.Price_Details}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>{STRINGS.Expiry}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>{STRINGS.Batch}</Text>
                    </View>
                    {(order.RELEASED_STATUS == 'B' || order.RELEASED_STATUS == 'D') && (
                        <View style={{ flexDirection: 'column', gap: 6 }}>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle2, { fontWeight: '400', textDecorationLine: 'line-through', maxWidth: width - 130 }]}>{order.ITEM_CODE}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>0</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{order.PRICE}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>-</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>-</Text>
                        </View>
                    )}
                    {(order.RELEASED_STATUS == 'B' || order.RELEASED_STATUS == 'D') && (
                        <View style={{ display: 'flex', position: 'absolute', right: 32, flexDirection: 'column', alignItems: 'flex-start', gap: 5, marginTop: 80, width: 100 }}>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751, textDecorationLine: 'line-through', }]}>{STRINGS.Tax_invoice} {order.TAX}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751, textDecorationLine: 'line-through', }]}>{STRINGS.Total_invoice} {order.TOTAL}</Text>
                        </View>
                    )}

                    {(order.RELEASED_STATUS != 'B' && order.RELEASED_STATUS != 'D') && (
                        <View style={{ flexDirection: 'column', gap: 6 }}>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400', maxWidth: width - 130 }]}>{order.ITEM_CODE}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{order.QTY}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{order.PRICE}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{order.EXP_DATE}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{order.BATCH}</Text>
                        </View>
                    )}
                    {(order.RELEASED_STATUS != 'B' && order.RELEASED_STATUS != 'D') && (
                        <View style={{ display: 'flex', position: 'absolute', right: 32, flexDirection: 'column', alignItems: 'flex-start', gap: 5, marginTop: 80, width: 100 }}>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751, }]}>{STRINGS.Tax_invoice} {order.TAX}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751 }]}>{STRINGS.Total_invoice} {order.TOTAL}</Text>
                        </View>
                    )}
                </View>
                <Text style={{}}></Text>
            </View>
        ));
        if (this.state.showInvoiceDetails) {
            return <View style={{ position: 'absolute', top: 0, left: 0, width, height, zIndex: 1001 }}>
                <TouchableOpacity
                    onPress={() => {
                        this.setState({ showInvoiceDetails: false });
                    }}
                    style={{ marginRight: 16, position: 'absolute', right: 20, top: 30, zIndex: 1003 }}>
                    <Image source={CloseIcon} style={{ width: 14, height: 14 }} />
                </TouchableOpacity>
                <InvoiceDetails
                    InvoiceNumber={this.state.detailsOrderInvoice}
                    InvoiceDate={this.state.detailsOrderDate}
                    InvoiceAmount={this.state.InvoiceValue} />
            </View>
        }
        return (
            <Animatable.View
                animation="slideInUp"
                duration={500}
                style={{
                    flex: 1,
                    position: 'absolute',
                    top: '0%',
                    transform: [{ translateX: -(width - 20) / 2 }, { translateY: -237.5 }],
                    zIndex: 1000,
                    flexDirection: 'column',
                    backgroundColor: 'white',
                    alignItems: 'center',
                    minHeight: '100%',
                    width: width
                }}>
                {this.renderHeaderDialog()}

                <View style={{ display: 'flex', width: width - 40, flexDirection: 'column', alignItems: 'flex-start', paddingHorizontal: 7 }}>
                    <Text style={[AppStyles.H2Styles]}>Order #{this.state.detailsOrderNo}</Text>
                    <TouchableOpacity onPress={async () => {
                        this.setState({ showInvoiceDetails: true });
                    }} style={{ marginTop: 5 }}>
                        <Text style={[AppStyles.ButtonTextStyles, { color: '#50B0FF', textDecorationLine: 'underline' }]}>Invoice #{this.state.detailsOrderInvoice} </Text>
                    </TouchableOpacity>
                    <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(59, 98, 127, 0.50)', marginTop: 10 }]}>{this.state.detailsOrderDate}</Text>
                </View>
                <ScrollView style={{ width: width - 40, marginTop: 32, flexDirection: 'column', gap: 32, height: height - 210 }}
                    showsVerticalScrollIndicator={false}
                >
                    <TouchableOpacity onPress={() => this.setState({ showOrderTimeline: !this.state.showOrderTimeline })}>
                        <View style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', alignSelf: 'stretch', paddingHorizontal: 8, flexDirection: 'row', width: width - 40 }}>
                            <Text style={[AppStyles.H3Styles]}>{STRINGS.Order_Timeline}</Text>
                            {this.state.orderTimeline.length > 1 && <Image source={imgArrowDown} style={{ width: 9.6, height: 5.8 }}></Image>}
                        </View>
                        {this.state.showOrderTimeline == true && (
                            <Animatable.View style={{ flexDirection: 'column', width: width - 40, alignSelf: 'stretch', paddingHorizontal: 8, marginTop: 10 }}
                                animation="slideInDown"
                                duration={600}>
                                {OrderTimeline}
                            </Animatable.View>
                        )}
                        {this.state.showOrderTimeline == false && (
                            this.getLastOrderItem()
                        )}
                    </TouchableOpacity>
                    <View style={{ display: 'flex', paddingHorizontal: 8, justifyContent: 'flex-start', alignSelf: 'stretch', marginTop: 30 }}>
                        <Text style={[AppStyles.H3Styles]}>{STRINGS.Order_Details}</Text>
                    </View>

                    <View style={{}}>
                        {OrderDetails}
                    </View>
                    <Text style={{ height: 56 }}></Text>

                </ScrollView>

            </Animatable.View >
        )
    }

    getLastOrderItem = () => {
        const TimelineCount = this.state.orderTimeline.length;
        const orderTimelineLastItem = this.state.orderTimeline.map((order, index) => (
            <View>
                {index == TimelineCount - 1 && (order.COLOR == '#6ba461' || order.COLOR == '#D70202') && TimelineCount - 1 != 0 && (
                    <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', alignSelf: 'stretch', backgroundColor: '#FFF', paddingHorizontal: 13, marginTop: 30 }}>
                        <View style={{ flexDirection: 'row', gap: 8, alignSelf: 'stretch' }}>
                            <View style={{ alignItems: 'center', justifyContent: 'center', alignSelf: 'stretch', flexDirection: 'column' }}>
                                <View style={{ height: 40, width: 4, backgroundColor: 'rgba(37, 89, 126, 0.09)', justifyContent: 'center', alignItems: 'center' }} />
                                <View style={{ width: 22, height: 22, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                            </View>
                            <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', flex: 1 }}>
                                <Text style={[AppStyles.H3Styles]}>{order.STATUS}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.COMMENT}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.DATE} </Text>
                            </View>
                        </View>
                    </View>
                )}
                {index == TimelineCount - 1 && order.COLOR != '#6ba461' && order.COLOR != '#D70202' && (
                    <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', alignSelf: 'stretch', backgroundColor: '#FFF', paddingHorizontal: 22, marginTop: 30 }}>
                        <View style={{ flexDirection: 'row', gap: 16, alignSelf: 'stretch' }}>
                            <View style={{ alignItems: 'center', justifyContent: 'center', alignSelf: 'stretch' }}>
                                <View style={{ height: 70, width: 4, backgroundColor: 'rgba(37, 89, 126, 0.09)', justifyContent: 'center', alignItems: 'center' }}>
                                    <View style={{ width: 22, height: 22, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                                </View>
                            </View>
                            <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', flex: 1 }}>
                                <Text style={[AppStyles.H3Styles]}>{order.STATUS}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.COMMENT}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.DATE} </Text>
                            </View>
                        </View>
                    </View>
                )}
            </View>
        ));
        return orderTimelineLastItem;
    };





    styles = () => ({
        container: {
            flex: 1,
            alignItems: "center",
            backgroundColor: WHITE
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            height: 590,
        }
    });
}



export default ClientHomePage;
